<template>
  <div class="col-12" id="skillForm">
    <div class="card">
      <div class="card-header">
        <div class="d-flex">
          <h4 class="mr-4">
            {{ skill.id === 0 ? 'Yo`nalish qo`shish' : 'Tahrirlash' }}
          </h4>
        </div>
      </div>
      <div class="card-content">
        <div class="card-body">
          <form class="form form-horizontal" enctype="multipart/form-data"
                @submit.prevent="submitForm">
            <div class="form-body">
              <div class="form-group mb-0">
                <div class="row">
                  <div class="col-md-6">
                    <fieldset class="form-label-group m-0 mb-md-0 mb-sm-2">
                      <input type="text" class="form-control" id="skillName"
                             placeholder="Nomlanishi"
                             v-model.trim="skill.name">
                      <label for="skillName">Nomlanishi</label>
                    </fieldset>
                  </div>
                  <div class="col mr-1">
                    <div class="form-group row">
                      <div class="col-md-3">
                        <label>Rasm</label>
                      </div>
                      <div class="col-md-9">
                        <div class="position-relative has-icon-left">
                          <div class="vs-checkbox-con vs-checkbox-primary">
                            <div id="upload-picture-large">
                              <upload-image
                                  :data-images="images"
                                  :multiple="false"
                                  :popup-text="'Rasm'"
                                  :primaryText="'Rasm skill'"
                                  :dragText="'Rasmni yuklash'"
                                  :browseText="''"
                                  @upload-success="uploadPictureSuccess"
                                  @before-remove="beforeRemovePicture"
                                  @edit-image="editPicture"
                                  idUpload="filePicture"
                                  editUpload="productUpdateEditId"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <div class="d-flex">
                      <button v-if="skill.id !== 0" type="submit" class="btn btn-info waves-effect waves-light mr-1">
                        Yangilash
                      </button>

                      <button v-else type="submit" class="btn btn-info waves-effect waves-light mr-1">
                        Saqlash
                      </button>
                    </div>
                  </div>
                </div>
                <!--                                <div class="col-md-3">-->
                <!--                                    <fieldset class="form-label-group  mb-md-0 mb-sm-2">-->
                <!--                                        <input type="number" class="form-control" id="displayOrder"-->
                <!--                                               placeholder="Tartibi"-->
                <!--                                               v-model.number="skill.displayOrder">-->

                <!--                                        <label for="displayOrder">Tartibi</label>-->
                <!--                                    </fieldset>-->
                <!--                                </div>-->
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SkillForm",
  props: {
    skill: Object
  },
  components: {},
  data() {
    return {
      formOpenCloseAttr: false,
      images: [],
      imageForm: new FormData()
    }
  },
  computed: {
    update() {
      return this.skill.id !== 0;
    }
  },
  methods: {
    formOpenClose() {
      this.formOpenCloseAttr = !this.formOpenCloseAttr
    },
    submitForm() {
      if (this.skill.id === 0) {
        this.storeSkill();
      } else {
        this.updateSkill();
      }
    },
    storeSkill() {
      this.$api.post(`admin/Reference/CreateSkill?Id=${this.skill.id}&Name=${this.skill.name}`)
          .then(res => {
            if (!res.error && res.statusCode === 200) {
              this.$emit('saved');
              this.notificationMessage('Сохранено', 'success')
            } else {
              this.notificationMessage(res.error, 'error')
            }
          })
          .catch(err => {
            this.notificationMessage('Ошибка', 'error')
          })
          .finally(() => {

          });
    },
    updateSkill() {
      this.$api.put(`admin/Reference/EditSkill?Id=${this.skill.id}&Name=${this.skill.name}`, this.skillFormData())
          .then(res => {
            if (!res.error && res.statusCode === 200) {
              this.$emit('saved');
              this.notificationMessage('Обновлено', 'success')
            } else {
              this.notificationMessage(res.error, 'error')
            }
          })
          .catch(err => {
            this.notificationMessage('Ошибка', 'error')
          })
          .finally(() => {

          });
    },
    skillFormData() {
      let form = new FormData();
      for (let prop in this.skill) {
        console.log(prop)
        if (prop === 'imageFormData' || prop !== 'picture')
          continue;
        form.append(prop, this.skill[prop]);
      }

      return form;
    },
    // UPLOAD PICTURE STARTED
    uploadPictureSuccess(formData, index, fileList) {
      this.skill.picture = formData.get('file');
    },
    beforeRemovePicture(index, done, fileList) {
      if (this.skill.picture) {
        this.deleteStoredImage(this.skill.picture);
        this.skill.picture = null;
      }
      done();
    },
    editPicture(formData, index, fileList) {
      this.images = [];
      this.skill.picture = null;
    },
    async deleteStoredImage(imageName) {
      let params = {};
      params.photo = imageName;
      return this.$api.post('file-uploads/delete-image', params).then(res => {
        if (res) {
          return res;
        } else {
          return false;
        }
      }).catch(error => {
        return false;
      }).finally(item => {
        ///
      });
    },
    setImage() {
      if (this.skill.picture !== null) {
        this.images = [];
        this.images.push(
            {
              path: `${this.baseURL}${this.skill.picture}`,
              default: 1,
              highlight: 1,
              caption: 'caption to display. receive', // Optional
            }
        );
      }
    }
    // UPLOAD PICTURE FINISHED
  },
  created() {
    console.log('im here')
    if (this.update && this.skill.picture) {
      console.log(this.skill.picture)
      this.setImage()
    }
  },
  watch: {
    skill() {
      this.setImage()
    }
  }
}
</script>

<style scoped>

</style>